import { render, staticRenderFns } from "./ItemAcquire.vue?vue&type=template&id=6efb873a&scoped=true&"
import script from "./ItemAcquire.vue?vue&type=script&lang=js&"
export * from "./ItemAcquire.vue?vue&type=script&lang=js&"
import style0 from "./ItemAcquire.vue?vue&type=style&index=0&id=6efb873a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb873a",
  null
  
)

export default component.exports